import type { FaireProductEntity } from "../../entity_types/product";

export const nyc_snack_4: FaireProductEntity = {
  token: "nyc-snack-4",
  type: "product",
  name: "Artisan Chocolate Chip Cookies",
  brandName: "Brooklyn Cookie Co.",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/245d98016865b8aec5fec7bfb250bc895d0504ecc6ffcf92f49696f167a07840.webp",
  priceDollars: 12,
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/245d98016865b8aec5fec7bfb250bc895d0504ecc6ffcf92f49696f167a07840.webp",
  weight: 0.7,
  dimensions: {
    width: 5,
    height: 5,
    depth: 2,
  },
  description: "Handcrafted chocolate chip cookies baked fresh in Brooklyn",
  categoryTokens: ["cat_food-snacks"],
  tags: ["nyc-local", "premium", "handmade", "brooklyn"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
